module.exports = __webpack_public_path__ + "img/Skip.57badb85.png";